import React, { useState, useEffect } from 'react'
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getFacultyByWing } from "../Services/FacultyService";
import Loader from '../Components/Loader';

const FacultyScreen = () => {
  const [activeTab, setActiveTab] = useState('Oasis-Gogji Bagh');
  const [faculties, setFaculties] = useState([]);

  useEffect(() => {
    if (faculties.length === 0) {
      getFaculty();
    }
  }, [activeTab, faculties]);

  const getFaculty = async () => {
    await getFacultyByWing(activeTab, setFaculties);
  }


  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <div>  <Helmet>
      <title>Faculty</title>
      <meta name="description" content=" Oasis Educational Institute" />
    </Helmet>

      <div >
        <Breadcrumbs page="Faculty" label="Home" path="/" />
        <div className="p-6 bg-gray-50 min-h-screen">
          <div className="flex justify-center space-x-4 mb-8">
            <button
              onClick={() => {
                setFaculties([]);
                setActiveTab('Oasis-Gogji Bagh')
              }}
              className={`px-6 py-2 rounded-lg ${activeTab === 'Oasis-Gogji Bagh'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700'
                }`}
            >
              Oasis Gogji Bagh
            </button>
            <button
              onClick={() => {
                setFaculties([]);
                setActiveTab('Oasis-Gulshan Nagar')
              }}
              className={`px-6 py-2 rounded-lg ${activeTab === 'Oasis-Gulshan Nagar'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700'
                }`}
            >
              Oasis Gulshan Nagar
            </button>
          </div>
          {faculties.length === 0 ? (<>
            <Loader />
          </>) : (<>
            <div className="mb-8 text-center">
              <h2 className="text-2xl  font-bold mb-4">Pre-Primary Department</h2>
              <Slider {...sliderSettings}>
                {faculties
                  .reduce((acc, faculty) => {
                    if (faculty.department === 'PPD') {
                      acc.push(faculty);
                    }
                    return acc;
                  }, [])
                  .map((faculty, index) => (
                    <div key={faculty.id} className="px-2">
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-xl font-semibold">{faculty.name}</h3>
                        <p className="text-gray-600">Designation: {faculty.designation}</p>
                        <p className="text-gray-600">Email: {faculty.email}</p>
                      </div>
                    </div>
                  ))}

              </Slider>
            </div>

            <div className="mb-8 text-center">
              <h2 className="text-2xl  font-bold mb-4">Lower Primary Department</h2>
              <Slider {...sliderSettings}>
                {faculties
                  .reduce((acc, faculty) => {
                    if (faculty.department === 'LPD') {
                      acc.push(faculty);
                    }
                    return acc;
                  }, [])
                  .map((faculty, index) => (
                    <div key={faculty.id} className="px-2">
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-xl font-semibold">{faculty.name}</h3>
                        <p className="text-gray-600">Designation: {faculty.designation}</p>
                        <p className="text-gray-600">Email: {faculty.email}</p>
                      </div>
                    </div>
                  ))}

              </Slider>
            </div>

            <div className="mb-8 text-center">
              <h2 className="text-2xl  font-bold mb-4">Upper Primary Department</h2>
              <Slider {...sliderSettings}>
                {faculties
                  .reduce((acc, faculty) => {
                    if (faculty.department === 'UPD') {
                      acc.push(faculty);
                    }
                    return acc;
                  }, [])
                  .map((faculty, index) => (
                    <div key={faculty.id} className="px-2">
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-xl font-semibold">{faculty.name}</h3>
                        <p className="text-gray-600">Designation: {faculty.designation}</p>
                        <p className="text-gray-600">Email: {faculty.email}</p>
                      </div>
                    </div>
                  ))}

              </Slider>
            </div>

            {activeTab === 'Oasis-Gulshan Nagar' && (<>
              <div className="mb-8 text-center">
                <h2 className="text-2xl  font-bold mb-4">
                  Special Educational Needs and Disabilities Department
                </h2>
                <Slider {...sliderSettings}>
                  {faculties
                    .reduce((acc, faculty) => {
                      if (faculty.department === 'SENDD') {
                        acc.push(faculty);
                      }
                      return acc;
                    }, [])
                    .map((faculty, index) => (
                      <div key={faculty.id} className="px-2">
                        <div className="bg-white p-6 rounded-lg shadow-md">
                          <h3 className="text-xl font-semibold">{faculty.name}</h3>
                          <p className="text-gray-600">Designation: {faculty.designation}</p>
                          <p className="text-gray-600">Email: {faculty.email}</p>
                        </div>
                      </div>
                    ))}

                </Slider>
              </div>
            </>)}

            <div className="mb-8 text-center">
              <h2 className="text-2xl  font-bold mb-4">Administrative Department</h2>
              <Slider {...sliderSettings}>
                {faculties
                  .reduce((acc, faculty) => {
                    if (faculty.department === 'Admin-dept') {
                      acc.push(faculty);
                    }
                    return acc;
                  }, [])
                  .map((faculty, index) => (
                    <div key={faculty.id} className="px-2">
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-xl font-semibold">{faculty.name}</h3>
                        <p className="text-gray-600">Designation: {faculty.designation}</p>
                        <p className="text-gray-600">Email: {faculty.email}</p>
                      </div>
                    </div>
                  ))}

              </Slider>
            </div>

          </>)}

        </div>
      </div>
    </div>
  )
}

export default FacultyScreen